const initialState = {
  loading: false,
  error: null,
  message: null,
  productGroupList: null,
  productGroup: null,
  productGroupFeatureList: null,
  productGroupFeature: null,
  productList: null,
  productListLoading: null,
  product: null,
  productTypeList: null,
  productType: null,
  featureList: null,
  feature: null,
  featureGroup: null,
  mapProductFeatureList: null,
  mapProductFeature: null,
  featureSynonym: null,
  // post_featureSynonym:null,
  featureGroupsList: null,
  featureGroups: null,
  landingPageList: null,
  landingPage: null,
  landingPageFaqList: null,
  // postlandingPageFaqResponse:null,
  landingPageFaq: null,
  landingPageSpgList: null,
  landingPageSpg: null,
  landingPageBannerList: null,
  landingPageBanner: null,
  sellableProductList: null,
  userProductList: null,
  userProduct: null,
  put_paymentDetailUpdate: null,
  put_paymentDetailUpdate_error: null,
  userProductSpg: null,
  // post_featureSynonym_error:null,
  post_cms_product_group_response_success: null,
  post_cms_product_group_response_failure: null,
  post_cms_productGroupFeatureList_response_success: null,
  post_cms_productGroupFeatureList_response_failure: null,
  post_cms_feature_response_success: null,
  post_cms_feature_response_failure: null,
  post_cms_mapProductFeatureList_response_success: null,
  post_cms_mapProductFeatureList_response_failure: null,
  post_cms_featureSynonym_response_success: null,
  post_cms_featureSynonym_response_failure: null,
  post_cms_product_response_success: null,
  post_cms_product_response_failure: null,
  post_cms_landingPage_response_success: null,
  post_cms_landingPage_response_failure: null,
  post_cms_landingPageSpg_response_success: null,
  post_cms_landingPageSpg_response_failure: null,
  post_cms_landingPageFaq_response_success: null,
  post_cms_landingPageFaq_response_failure: null,
  post_cms_landingPageBannerList_response_success: null,
  post_cms_landingPageBannerList_response_failure: null,
  delete_cms_feature_synonyms_response: null,
  delete_cms_feature_synonyms_error: null,
  post_cms_feature_groups_success: null,
  post_cms_feature_groups_failure: null,
  landingMessage: null,
  spgMessage: null,
  faqMessage: null,
  productEntityMappedTypeList: null,
  productEntityMappedTypeloading: null,
  productSellebleTypeList: null,
  productMappedEntityCheckloading: null,
  productMappedEntityCheck: null,
  productMappedEntityCheckError: null,
  productSpgTypeList: null,
  productMappedTypeList: null,
  productMappedListLoading: null,
  productMappedList: null,
  productLearnListLoading: null,
  productLearnList: null,
  productAutoAccessLoading: null,
  productAutoAccess: null,
  productSpgInterestLoading: null,
  productSpgInterestType: null,
  productAdditionalMappingLoading: null,
  productAdditionalMappingType: null,
  productEntityValidateLoading: false,
  productEntityValidateType: null,
  productEntityValidateError: null,
  spgLevelLoading: null,
  spgLevelList: null,
  productMappedEntityloading: null,
  productMappedEntity: null,
  productMappedEntityError: null,
  mapProductsDataloading: null,
  mapProductsData: null,
  mapProductsDataError: null,
  putProductSpgMappingloading: null,
  putProductSpgMappingData: null,
  putProductSpgMappingError: null
};

const ProductsReducer = (state = initialState, action) => {
  switch (action.type) {
    case "GET_CMS_PRODUCTS_LIST_REQUEST":
      return {
        ...state,
        loading: true,
      };
    case "GET_CMS_PRODUCTS_LIST_SUCCESS":
      return {
        ...state,
        loading: false,
        productGroupList: action.payload,
      };
    case "GET_CMS_PRODUCTS_LIST_FAILURE":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case "CLEAR_PRODUCTS_LIST":
      return {
        ...state,
        productGroupList: null,
      };
    case "GET_CMS_PRODUCT_GROUP_REQUEST":
      return {
        ...state,
        loading: true,
      };
    case "GET_CMS_PRODUCT_GROUP_SUCCESS":
      return {
        ...state,
        loading: false,
        productGroup: action.payload,
      };
    case "GET_CMS_PRODUCT_GROUP_FAILURE":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case "CLEAR_PRODUCT_GROUP":
      return {
        ...state,
        productGroup: null,
      };
    case "POST_CMS_PRODUCT_GROUP_SUCCESS":
      return {
        ...state,
        post_cms_product_group_response_success: action.payload,
        message: "Product Group Added Successfully",
      };
    case "POST_CMS_PRODUCT_GROUP_FAILURE":
      return {
        ...state,
        post_cms_product_group_response_failure: action.payload,
        message: "Error in adding Product Group",
      };
    case "CLEAR_PRODUCT_GROUP_RESPONSE":
      return {
        ...state,
        message: null,
        error: null,
        post_cms_product_group_response_success: null,
        post_cms_product_group_response_failure: null,
      };
    case "GET_CMS_PRODUCT_GROUP_FEATURE_LIST_REQUEST":
      return {
        ...state,
        loading: true,
      };
    case "GET_CMS_PRODUCT_GROUP_FEATURE_LIST_SUCCESS":
      return {
        ...state,
        loading: false,
        productGroupFeatureList: action.payload,
      };
    case "GET_CMS_PRODUCT_GROUP_FEATURE_LIST_FAILURE":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case "GET_CMS_PRODUCT_SPG_TYPE_LIST_REQUEST":
      return {
        ...state,
        loading: true,
      };
    case "GET_CMS_PRODUCT_SPG_TYPE_LIST_SUCCESS":
      return {
        ...state,
        loading: false,
        productSpgTypeList: action.payload,
      };
    case "GET_CMS_PRODUCT_SPG_TYPE_LIST_FAILURE":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case "GET_CMS_MAPPED_TYPE_LIST_REQUEST":
      return {
        ...state,
        loading: true,
      };
    case "GET_CMS_MAPPED_TYPE_LIST_SUCCESS":
      return {
        ...state,
        loading: false,
        productMappedTypeList: action.payload,
      };
    case "GET_CMS_MAPPED_LIST_FAILURE":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case "GET_CMS_MAPPED_LIST_REQUEST":
      return {
        ...state,
        productMappedListLoading: true,
      };
    case "GET_CMS_MAPPED_LIST_SUCCESS":
      return {
        ...state,
        productMappedListLoading: false,
        productMappedList: action.payload,
      };
    case "GET_CMS_MAPPED_TYPE_LIST_FAILURE":
      return {
        ...state,
        productMappedListLoading: false,
        error: action.payload,
      };
    case "GET_CMS_LEARN_LIST_REQUEST":
      return {
        ...state,
        productLearnListLoading: true,
      };
    case "GET_CMS_LEARN_LIST_SUCCESS":
      return {
        ...state,
        productLearnListLoading: false,
        productLearnList: action.payload,
      };
    case "GET_CMS_LEARN_TYPE_LIST_FAILURE":
      return {
        ...state,
        productLearnListLoading: false,
        error: action.payload,
      };
    case "GET_CMS_AUTO_ACCESS_REQUEST":
      return {
        ...state,
        productAutoAccessLoading: true,
      };
    case "GET_CMS_AUTO_ACCESS_SUCCESS":
      return {
        ...state,
        productAutoAccessLoading: false,
        productAutoAccess: action.payload,
      };
    case "GET_CMS_AUTO_ACCESS_FAILURE":
      return {
        ...state,
        productAutoAccessLoading: false,
        error: action.payload,
      };
    case "GET_CMS_SPG_INTEREST_REQUEST":
      return {
        ...state,
        productSpgInterestLoading: true,
      };
    case "GET_CMS_SPG_INTEREST_SUCCESS":
      return {
        ...state,
        productSpgInterestLoading: false,
        productSpgInterestType: action.payload,
      };
    case "GET_CMS_SPG_INTEREST_FAILURE":
      return {
        ...state,
        productSpgInterestLoading: false,
        error: action.payload,
      };
    case "GET_CMS_ADDITIONAL_MAPPING_FIELD_REQUEST":
      return {
        ...state,
        productAdditionalMappingLoading: true,
      };
    case "GET_CMS_ADDITIONAL_MAPPING_FIELD_SUCCESS":
      return {
        ...state,
        productAdditionalMappingLoading: false,
        productAdditionalMappingType: action.payload,
      };
    case "GET_CMS_ADDITIONAL_MAPPING_FIELD_FAILURE":
      return {
        ...state,
        productAdditionalMappingLoading: false,
        error: action.payload,
      };
    case "GET_CMS_ENTITY_VALIDATE_REQUEST_REQUEST":
      return {
        ...state,
        productEntityValidateLoading: true,
      };
    case "GET_CMS_ENTITY_VALIDATE_SUCCESS":
      return {
        ...state,
        productEntityValidateLoading: false,
        productEntityValidateType: action.payload,
      };
    case "GET_CMS_ENTITY_VALIDATE_FAILURE":
      return {
        ...state,
        productEntityValidateLoading: false,
        productEntityValidateError: action.payload,
      };
    case "CLEAR_CMS_ENTITY_VALIDATE_RESPONSE":
      return {
        ...state,
        productEntityValidateLoading: false,
        productEntityValidateError: null,
      };
    case "GET_CMS_SPG_LEVELS_REQUEST":
      return {
        ...state,
        spgLevelLoading: true,
      };
    case "GET_CMS_SPG_LEVELS_SUCCESS":
      return {
        ...state,
        spgLevelLoading: false,
        spgLevelList: action.payload,
      };
    case "GET_CMS_SPG_LEVELS_FAILURE":
      return {
        ...state,
        spgLevelLoading: false,
        error: action.payload,
      };
    case "PRODUCT_GROUP_FEATURE_LIST":
      return {
        ...state,
        productGroupFeatureList: null,
      };
    case "POST_CMS_PRODUCT_GROUP_FEATURE_SUCCESS":
      return {
        ...state,
        post_cms_productGroupFeatureList_response_success: action.payload,
        message: "Product Group Feature Added Successfully",
      };
    case "POST_CMS_PRODUCT_GROUP_FEATURE_FAILURE":
      return {
        ...state,
        post_cms_productGroupFeatureList_response_failure: action.payload,
        message: "Failure in Adding Product Group Feature",
      };
    case "CLEAR_PRODUCT_GROUP_FEATURE_RESPONSE":
      return {
        ...state,
        message: null,
        error: null,
        post_cms_productGroupFeatureList_response_success: null,
        post_cms_productGroupFeatureList_response_failure: null,
      };
    case "GET_CMS_FEATURE_LIST_REQUEST":
      return {
        ...state,
        loading: true,
      };
    case "GET_CMS_FEATURE_LIST_SUCCESS":
      return {
        ...state,
        loading: false,
        featureList: action.payload,
      };
    case "GET_CMS_FEATURE_LIST_FAILURE":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case "CLEAR_FEATURE_LIST":
      return {
        ...state,
        featureList: null,
      };
    case "GET_CMS_FEATURE_REQUEST":
      return {
        ...state,
        loading: true,
      };
    case "GET_CMS_FEATURE_SUCCESS":
      return {
        ...state,
        loading: false,
        feature: action.payload,
      };
    case "GET_CMS_FEATURE_FAILURE":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case "CLEAR_FEATURE":
      return {
        ...state,
        feature: null,
      };
    case "POST_CMS_FEATURE_SUCCESS":
      return {
        ...state,
        post_cms_feature_response_success: action.payload,
        message: "Feature Added Successfully",
      };
    case "POST_CMS_FEATURE_FAILURE":
      return {
        ...state,
        post_cms_feature_response_failure: action.payload,
        message: "Error in adding Feature",
      };
    case "CLEAR_FEATURE_RESPONSE":
      return {
        ...state,
        message: null,
        error: null,
        post_cms_feature_response_success: null,
        post_cms_feature_response_failure: null,
      };
    case "GET_CMS_FEATURE_SYNONYM_REQUEST":
      return {
        ...state,
        loading: true,
      };
    case "GET_CMS_FEATURE_SYNONYM_SUCCESS":
      return {
        ...state,
        featureSynonym: action.payload,
        loading: false,
      };
    case "GET_CMS_FEATURE_SYNONYM_FAILURE":
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    case "CLEAR_FEATURE_SYNONYM":
      return {
        ...state,
        featureSynonym: null,
      };
    case "POST_CMS_FEATURE_SYNONYM_SUCCESS":
      return {
        // post_featureSynonym:action.payload,
        ...state,
        post_cms_featureSynonym_response_success: action.payload,
        message: "Feature Synonym Added Successfully",
      };
    case "POST_CMS_FEATURE_SYNONYM_FAILURE":
      return {
        ...state,
        post_cms_featureSynonym_response_failure: action.payload,
        message: "Error in adding Feature Synonym",
        // post_featureSynonym_error:action.payload
      };
    case "CLEAR_FEATURE_SYNONYM_RESPONSE":
      return {
        ...state,
        message: null,
        error: null,
        post_cms_featureSynonym_response_success: null,
        post_cms_featureSynonym_response_failure: null,
      };
    case "GET_CMS_FEATURE_GROUPS_LIST_REQUEST":
      return {
        ...state,
        loading: true,
      };
    case "GET_CMS_FEATURE_GROUPS_LIST_SUCCESS":
      return {
        ...state,
        loading: false,
        featureGroupsList: action.payload,
      };
    case "GET_CMS_FEATURE_GROUPS_LIST_FAILURE":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case "CLEAR_FEATURE_GROUPS_LIST":
      return {
        ...state,
        featureGroupsList: null,
      };
    case "POST_CMS_FEATURE_GROUPS_SUCCESS":
      return {
        ...state,
        post_cms_feature_groups_success: action.payload,
        message: "Feature Group Added Successfully",
      };
    case "POST_CMS_FEATURE_GROUPS_FAILURE":
      return {
        ...state,
        post_cms_feature_groups_failure: action.payload,
        message: "Error in adding Feature Group",
      };
    case "CLEAR_FEATURE_GROUPS_RESPONSE":
      return {
        ...state,
        message: null,
        error: null,
        post_cms_feature_groups_success: null,
        post_cms_feature_groups_failure: null,
      };
    case "GET_CMS_FEATURE_GROUPS_REQUEST":
      return {
        ...state,
        loading: true,
      };
    case "GET_CMS_FEATURE_GROUPS_SUCCESS":
      return {
        ...state,
        loading: false,
        featureGroups: action.payload,
      };
    case "GET_CMS_FEATURE_GROUPS_FAILURE":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case "CLEAR_FEATURE_GROUPS":
      return {
        ...state,
        featureGroups: null,
      };
    case "GET_CMS_PRODUCT_LIST_REQUEST":
      return {
        ...state,
        productListLoading: true,
      };
    case "GET_CMS_PRODUCT_LIST_SUCCESS":
      return {
        ...state,
        productListLoading: false,
        productList: action.payload,
      };
    case "GET_CMS_PRODUCT_LIST_FAILURE":
      return {
        ...state,
        productListLoading: false,
        error: action.payload,
      };
    case "POST_CMS_PRODUCT_SUCCESS":
      return {
        ...state,
        post_cms_product_response_success: action.payload,
        message: "Product Added Successfully",
      };

    case "POST_CMS_PRODUCT_FAILURE":
      return {
        ...state,
        post_cms_product_response_failure: action.payload,
        message: "Failure in Adding Product",
      };
    case "CLEAR_PRODUCT_RESPONSE":
      return {
        ...state,
        message: null,
        error: null,
        post_cms_product_response_success: null,
        post_cms_product_response_failure: null,
      };
    case "GET_CMS_PRODUCT_REQUEST":
      return {
        ...state,
        loading: true,
      };
    case "GET_CMS_PRODUCT_SUCCESS":
      return {
        ...state,
        loading: false,
        product: action.payload,
      };
    case "GET_CMS_PRODUCT_FAILURE":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case "CLEAR_PRODUCT":
      return {
        ...state,
        product: null,
      };
    case "GET_CMS_PRODUCT_TYPE_LIST_REQUEST":
      return {
        ...state,
        loading: true,
      };
    case "GET_CMS_PRODUCT_TYPE_LIST_SUCCESS":
      return {
        ...state,
        loading: false,
        productTypeList: action.payload,
      };
    case "GET_CMS_PRODUCT_TYPE_LIST_FAILURE":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case "GET_CMS_PRODUCT_ENTITY_MAPPED_REQUEST":
      return {
        ...state,
        productEntityMappedTypeloading: true,
      };
    case "GET_CMS_PRODUCT_ENTITY_MAPPED_SUCCESS":
      return {
        ...state,
        productEntityMappedTypeloading: false,
        productEntityMappedTypeList: action.payload,
      };
    case "GET_CMS_PRODUCT_ENTITY_MAPPED_FAILURE":
      return {
        ...state,
        productEntityMappedTypeloading: false,
        error: action.payload,
      };
    case "GET_CMS_PRODUCT_SELLEBLE_TYPE_REQUEST":
      return {
        ...state,
        loading: true,
      };
    case "GET_CMS_PRODUCT_SELLEBLE_TYPE_SUCCESS":
      return {
        ...state,
        loading: false,
        productSellebleTypeList: action.payload,
      };
    case "GET_CMS_PRODUCT_SELLEBLE_TYPE_FAILURE":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case "GET_CMS_PRODUCT_MAPPED_ENTITY_CHECK_REQUEST":
      return {
        ...state,
        productMappedEntityCheckloading: true,
      };
    case "GET_CMS_PRODUCT_MAPPED_ENTITY_CHECK_SUCCESS":
      return {
        ...state,
        productMappedEntityCheckloading: false,
        productMappedEntityCheck: action.payload,
      };
    case "GET_CMS_PRODUCT_MAPPED_ENTITY_CHECK_FAILURE":
      return {
        ...state,
        productMappedEntityCheckloading: false,
        productMappedEntityCheckError: action.payload,
      };
    case "CLEAR_PRODUCT_MAPPED_ENTITY_CHECK_RESPONSE":
      return {
        ...state,
        productMappedEntityCheckloading: false,
        productMappedEntityCheckError: null,
      };
    case "POST_CMS_PRODUCT_TYPE_SUCCESS":
      return {
        ...state,
        productTypeList: [...state.productTypeList, action.payload],
        message: "Product Type Added Successfully",
        error: false,
      };
    case "CLEAR_PRODUCT_TYPE_RESPONSE":
      return {
        ...state,
        message: null,
        error: null,
      };
    case "GET_CMS_PRODUCT_TYPE_REQUEST":
      return {
        ...state,
        loading: true,
      };
    case "GET_CMS_PRODUCT_TYPE_SUCCESS":
      return {
        ...state,
        loading: false,
        productType: action.payload,
      };
    case "GET_CMS_PRODUCT_TYPE_FAILURE":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case "CLEAR_PRODUCT_TYPE":
      return {
        ...state,
        productType: null,
      };
    case "GET_CMS_MAP_PRODUCT_FEATURE_LIST_REQUEST":
      return {
        ...state,
        loading: true,
      };
    case "GET_CMS_MAP_PRODUCT_FEATURE_LIST_SUCCESS":
      return {
        ...state,
        loading: false,
        mapProductFeatureList: action.payload,
      };
    case "GET_CMS_MAP_PRODUCT_FEATURE_LIST_FAILURE":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case "POST_CMS_MAP_PRODUCT_FEATURE_SUCCESS":
      return {
        ...state,
        post_cms_mapProductFeatureList_response_success: action.payload,
        message: "Map Product feature Added Successfully",
      };
    case "POST_CMS_MAP_PRODUCT_FEATURE_FAILURE":
      return {
        ...state,
        post_cms_mapProductFeatureList_response_failure: action.payload,
        message: "Failure in Adding Map Product feature",
      };
    case "CLEAR_MAP_PRODUCT_FEATURE_RESPONSE":
      return {
        ...state,
        message: null,
        error: null,
        post_cms_mapProductFeatureList_response_success: null,
        post_cms_mapProductFeatureList_response_failure: null,
      };
    case "GET_CMS_MAP_PRODUCT_FEATURE_REQUEST":
      return {
        ...state,
        loading: true,
      };
    case "GET_CMS_MAP_PRODUCT_FEATURE_SUCCESS":
      return {
        ...state,
        loading: false,
        mapProductFeature: action.payload,
      };
    case "GET_CMS_MAP_PRODUCT_FEATURE_FAILURE":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case "CLEAR_MAP_PRODUCT_FEATURE":
      return {
        ...state,
        mapProductFeature: null,
      };
    case "GET_CMS_LANDING_PAGE_LIST_REQUEST":
      return {
        ...state,
        loading: true,
      };
    case "GET_CMS_LANDING_PAGE_LIST_SUCCESS":
      return {
        ...state,
        loading: false,
        landingPageList: action.payload,
      };
    case "GET_CMS_LANDING_PAGE_LIST_FAILURE":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case "CLEAR_LANDING_PAGE_LIST":
      return {
        ...state,
        landingPageList: null,
      };
    case "POST_CMS_LANDING_PAGE_SUCCESS":
      return {
        ...state,
        post_cms_landing_response_success: action.payload,
        landingMessage: "Landing Page Added Successfully",
      };
    case "POST_CMS_LANDING_PAGE_FAILURE":
      return {
        ...state,
        post_cms_landing_response_failure: action.payload,
        landingMessage: "Failure in Adding Landing Page",
      };
    case "CLEAR_LANDING_PAGE_RESPONSE":
      return {
        ...state,
        message: null,
        error: null,
        post_cms_landing_response_success: null,
        post_cms_landing_response_failure: null,
      };
    case "GET_CMS_LANDING_PAGE_REQUEST":
      return {
        ...state,
        loading: true,
      };
    case "GET_CMS_LANDING_PAGE_SUCCESS":
      return {
        ...state,
        loading: false,
        landingPage: action.payload,
      };
    case "GET_CMS_LANDING_PAGE_FAILURE":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case "CLEAR_LANDING_PAGE":
      return {
        ...state,
        landingPage: null,
      };
    case "CLEAR_LANDING_NOTIFICATIONS":
      return {
        ...state,
        landingMessage: null,
        spgMessage: null,
        faqMessage: null,
        post_cms_landing_response_failure: null,
      };
    case "GET_CMS_LANDING_PAGE_FAQ_LIST_REQUEST":
      return {
        ...state,
        loading: true,
      };
    case "GET_CMS_LANDING_PAGE_FAQ_LIST_SUCCESS":
      return {
        ...state,
        loading: false,
        landingPageFaqList: action.payload,
      };
    case "GET_CMS_LANDING_PAGE_FAQ_LIST_FAILURE":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case "POST_CMS_LANDING_PAGE_FAQ_SUCCESS":
      return {
        ...state,
        // postlandingPageFaqResponse:action.payload,
        post_cms_landingPageFaq_response_success: action.payload,
        faqMessage: "FAQs Added Successfully",
      };
    case "POST_CMS_LANDING_PAGE_FAQ_FAILURE":
      return {
        ...state,
        post_cms_landingPageFaq_response_failure: action.payload,
        faqMessage: "Failure in Adding Faq",
      };
    case "CLEAR_LANDING_PAGE_FAQ_RESPONSE":
      return {
        ...state,
        message: null,
        error: null,
        post_cms_landingPageFaq_response_success: null,
        post_cms_landingPageFaq_response_failure: null,
        // postlandingPageFaqResponse:null
      };
    case "GET_CMS_LANDING_PAGE_FAQ_REQUEST":
      return {
        ...state,
        loading: true,
      };
    case "GET_CMS_LANDING_PAGE_FAQ_SUCCESS":
      return {
        ...state,
        loading: false,
        landingPageFaq: action.payload,
      };
    case "GET_CMS_LANDING_PAGE_FAQ_FAILURE":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case "CLEAR_LANDING_PAGE_FAQ":
      return {
        ...state,
        landingPageFaq: null,
      };
    case "GET_CMS_LANDING_PAGE_SPG_LIST_REQUEST":
      return {
        ...state,
        loading: true,
      };
    case "GET_CMS_LANDING_PAGE_SPG_LIST_SUCCESS":
      return {
        ...state,
        loading: false,
        landingPageSpgList: action.payload,
      };
    case "GET_CMS_LANDING_PAGE_SPG_LIST_FAILURE":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case "POST_CMS_LANDING_PAGE_SPG_SUCCESS":
      return {
        ...state,
        post_cms_landingPageSpg_response_success: action.payload,
        spgMessage: "Spg Added Successfully",
      };
    case "POST_CMS_LANDING_PAGE_SPG_FAILURE":
      return {
        ...state,
        post_cms_landingPageSpg_response_failure: action.payload,
        spgMessage: "Failure in Adding Spg",
      };
    case "CLEAR_LANDING_PAGE_SPG_RESPONSE":
      return {
        ...state,
        message: null,
        error: null,
        post_cms_landingPageSpg_response_success: null,
        post_cms_landingPageSpg_response_failure: null,
      };
    case "GET_CMS_LANDING_PAGE_SPG_REQUEST":
      return {
        ...state,
        loading: true,
      };
    case "GET_CMS_LANDING_PAGE_SPG_SUCCESS":
      return {
        ...state,
        loading: false,
        landingPageSpg: action.payload,
      };
    case "GET_CMS_LANDING_PAGE_SPG_FAILURE":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case "CLEAR_LANDING_PAGE_SPG":
      return {
        ...state,
        landingPageSpg: null,
      };
    case "GET_CMS_LANDING_PAGE_BANNER_LIST_REQUEST":
      return {
        ...state,
        loading: true,
      };
    case "GET_CMS_LANDING_PAGE_BANNER_LIST_SUCCESS":
      return {
        ...state,
        loading: false,
        landingPageBannerList: action.payload,
      };
    case "GET_CMS_LANDING_PAGE_BANNER_LIST_FAILURE":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case "CLEAR_LANDING_PAGE_BANNER_LIST":
      return {
        ...state,
        landingPageBannerList: null,
      };
    case "GET_CMS_LANDING_PAGE_BANNER_REQUEST":
      return {
        ...state,
        loading: true,
      };
    case "GET_CMS_LANDING_PAGE_BANNER_SUCCESS":
      return {
        ...state,
        loading: false,
        landingPageBanner: action.payload,
      };
    case "GET_CMS_LANDING_PAGE_BANNER_FAILURE":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case "CLEAR_LANDING_PAGE_BANNER":
      return {
        ...state,
        landingPageBanner: null,
      };
    case "POST_CMS_LANDING_PAGE_BANNER_SUCCESS":
      return {
        ...state,
        post_cms_landingPageBannerList_response_success: action.payload,
        message: "Landing Page Banner Added Successfully",
      };
    case "POST_CMS_LANDING_PAGE_BANNER_FAILURE":
      return {
        ...state,
        post_cms_landingPageBannerList_response_failure: action.payload,
        message: "Failure in Adding Landing Page Banner ",
      };
    case "CLEAR_LANDING_PAGE_BANNER_RESPONSE":
      return {
        ...state,
        message: null,
        error: null,
        post_cms_landingPageBannerList_response_success: null,
        post_cms_landingPageBannerList_response_failure: null,
      };
    case "GET_CMS_USER_PRODUCT_LIST_REQUEST":
      return {
        ...state,
        loading: true,
      };
    case "GET_CMS_USER_PRODUCT_LIST_SUCCESS":
      return {
        ...state,
        loading: false,
        userProductList: action.payload,
      };
    case "GET_CMS_USER_PRODUCT_LIST_FAILURE":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case "CLEAR_USER_PRODUCT_LIST":
      return {
        ...state,
        userProductList: null,
      };
    case "POST_CMS_USER_PRODUCT_SUCCESS":
      return {
        ...state,
        userProductList: [...state.userProductList, action.payload],
        message: "User Product Added Successfully",
        error: false,
      };
    case "CLEAR_USER_PRODUCT_RESPONSE":
      return {
        ...state,
        message: null,
        error: null,
      };
    case "GET_CMS_USER_PRODUCT_REQUEST":
      return {
        ...state,
        loading: true,
      };
    case "GET_CMS_USER_PRODUCT_SUCCESS":
      return {
        ...state,
        loading: false,
        userProduct: action.payload,
      };
    case "GET_CMS_USER_PRODUCT_FAILURE":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case "CLEAR_USER_PRODUCT":
      return {
        ...state,
        userProduct: null,
      };
    case "PUT_PAYMENT_DETAIL_UPDATE_SUCCESS":
      return {
        ...state,
        put_paymentDetailUpdate: action.payload,
      };
    case "PUT_PAYMENT_DETAIL_UPDATE_FAILURE":
      return {
        ...state,
        put_paymentDetailUpdate_error: action.payload,
      };

    case "POST_CMS_USER_PRODUCT_SPG_SUCCESS":
      return {
        ...state,
        userProductSpg: action.payload,
      };
    case "POST_CMS_USER_PRODUCT_SPG_FAILURE":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case "DELETE_CMS_FEATURE_SYNONYMS_SUCCESS":
      return {
        ...state,
        delete_cms_feature_synonyms_response: action.payload,
      };
    case "DELETE_CMS_FEATURE_SYNONYMS_FAILURE":
      return {
        ...state,
        delete_cms_feature_synonyms_error: action.payload,
      };
    case "GET_CMS_FEATURE_GROUP_REQUEST":
      return {
        ...state,
        loading: true,
      };
    case "GET_CMS_FEATURE_GROUP_SUCCESS":
      return {
        ...state,
        loading: false,
        featureGroup: action.payload,
      };
    case "GET_CMS_FEATURE_GROUP_FAILURE":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case "GET_PRODUCT_MAPPED_ENTITY_REQUEST":
      return {
        ...state,
        productMappedEntityloading: true,
      };
    case "GET_PRODUCT_MAPPED_ENTITY_SUCCESS":
      return {
        ...state,
        productMappedEntityloading: false,
        productMappedEntity: action.payload,
      };
    case "GET_PRODUCT_MAPPED_ENTITY_FAILURE":
      return {
        ...state,
        productMappedEntityloading: false,
        productMappedEntityError: action.payload,
      };
    case "GET_MAP_PRODUCTS_DATA_REQUEST":
      return {
        ...state,
        mapProductsDataloading: true,
      };
    case "GET_MAP_PRODUCTS_DATA_SUCCESS":
      return {
        ...state,
        mapProductsDataloading: false,
        mapProductsData: action.payload,
      };
    case "GET_MAP_PRODUCTS_DATA_FAILURE":
      return {
        ...state,
        mapProductsDataloading: false,
        mapProductsDataError: action.payload,
      };
    case "CLEAR_MAP_PRODUCTS_DATA_RESPONSE":
      return {
        ...state,
        mapProductsDataloading: false,
        mapProductsDataError: null,
        mapProductsData: null
      };
    case "PUT_PRODUCT_SPG_MAPPING_SUCCESS":
      return {
        ...state,
        putProductSpgMappingloading: false,
        putProductSpgMappingData: action.payload,
      };
    case "PUT_PRODUCT_SPG_MAPPING_FAILURE":
      return {
        ...state,
        putProductSpgMappingloading: false,
        putProductSpgMappingError: action.payload,
      };
    case "CLEAR_PRODUCT_SPG_MAPPING_RESPONSE":
      return {
        ...state,
        putProductSpgMappingloading: false,
        putProductSpgMappingError: null,
        putProductSpgMappingData: null
      };
    default:
      return state;
  }
};

export default ProductsReducer;
